<div class="select-header-user__header select-header-user_theme-2" (click)="selectComponent.toggle()">
  <i class="select-header-user__icon" [ngClass]="icon"></i>
  @if (selectComponent.selectedModel.length === 0) {
    <div class="select-header-user__placeholder">{{ placeholder }}</div>
  }

  <div class="select-header-user__items">
    <ng-content class="select-header-user__avatar" select="[items]"></ng-content>
  </div>
</div>
